export const SET_MEMBER = 'profile/setMember'
export const SET_ROLE = 'profile/setRole'
export const SET_PREFERENCES = 'profile/setPreferences'
export const SET_INTEGRATIONS = 'profile/setIntegrations'
export const SET_NOTIFICATIONS = 'profile/setNotifications'
export const SAVE_NOTIFICATION = 'profile/saveNotification'
export const CLEAR_STATE = 'profile/clearState'



// WEBPACK FOOTER //
// ./src/modules/profile/store/mutations_types.js